import { render, staticRenderFns } from "./automatic-rule-table.vue?vue&type=template&id=61cdd19d&scoped=true&"
import script from "./automatic-rule-table.vue?vue&type=script&lang=js&"
export * from "./automatic-rule-table.vue?vue&type=script&lang=js&"
import style0 from "./automatic-rule-table.vue?vue&type=style&index=0&id=61cdd19d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cdd19d",
  null
  
)

export default component.exports